import React from "react";
import { ArrowUpRight } from "lucide-react";
import PageShell from "./_PageShell";
import { mailtoLink } from "../config/contacts";

const TOPICS = [
  { t: "Keynotes", d: "On Islamic education, leadership, and the inner life." },
  { t: "Khutbahs", d: "Friday sermons rooted in scripture and lived reality." },
  { t: "Fireside Talks", d: "Intimate evenings for students, teachers and families." },
  { t: "Corporate", d: "Faith, ethics and meaning for Muslim professionals." },
];

const Speaking = () => (
  <PageShell
    testId="speaking-page"
    eyebrow="03 — Speaking"
    title="On stage. In hearts."
    intro="Keynotes, khutbahs and fireside talks for schools, masajid, conferences and corporate teams — delivered with clarity, depth and the warmth of a teacher who still believes in the human soul."
  >
    <div className="grid md:grid-cols-2 gap-6">
      {TOPICS.map((x) => (
        <div key={x.t} className="border border-white/10 p-8 bg-ink-soft/30 hover:border-gold transition-colors">
          <div className="font-serif text-white text-2xl">{x.t}</div>
          <p className="text-white/65 mt-3 leading-relaxed text-sm">{x.d}</p>
        </div>
      ))}
    </div>
    <div className="mt-14 flex flex-col sm:flex-row gap-4">
      <a
        href={mailtoLink("booking", "Speaking Inquiry")}
        data-testid="speaking-book-speak-btn"
        className="group inline-flex items-center justify-center gap-3 bg-azure hover:bg-[#5C9BEC] text-white px-7 py-3.5 text-[11px] tracking-[0.32em] uppercase font-medium transition-all"
      >
        Book Iyare to Speak
        <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-400 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.8} />
      </a>
      <a
        href={mailtoLink("booking", "Workshop Inquiry")}
        data-testid="speaking-book-workshop-btn"
        className="group inline-flex items-center justify-center gap-3 border border-white/40 hover:border-gold hover:text-gold text-white px-7 py-3.5 text-[11px] tracking-[0.32em] uppercase font-medium transition-all"
      >
        Book a Workshop
        <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-400 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.8} />
      </a>
    </div>
  </PageShell>
);

export default Speaking;
